import http from "../http-common";
import authHeader from "./authHeader";
import { ROLE_API } from "../api";
const getAllRoles = () => {
  return http.get(`${ROLE_API}`, { headers: authHeader() });
};

const getRoleById = (id) => {
  return http.get(`${ROLE_API}/${id}`, { headers: authHeader() });
};

const createRole = (data) => {
  return http.post(`${ROLE_API}`, data, { headers: authHeader() });
};
const resignRole = (id) => {
  return http.put(`${ROLE_API}/${id}`, { role: null }, { headers: authHeader() });
};
const updateRole = (id, data) => {
  return http.put(`${ROLE_API}/${id}`, data, { headers: authHeader() });
};

const removeRole = (id) => {
  return http.delete(`${ROLE_API}/${id}`, { headers: authHeader() });
};

const RoleService = {
  getAllRoles,
  getRoleById,
  createRole,
  updateRole,
  removeRole,
  resignRole,
};

export default RoleService;
